import React, { useState, useRef, useEffect, startTransition } from 'react';
import styles from './FJLanguageListMenu.module.less';
import SearchIcon from '../../../../../assets/svg/search.svg?react';
import CheckIcon from '../../../../../assets/svg/check.svg?react';
import OppsIcon from '../../../../../assets/svg/oops.svg?react';
import DeleteSearchIcon from '../../../../../assets/svg/delete-search.svg?react';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import _ from 'lodash';
import FJVerticalScroller from '../../../../../common/components/FJScroller/FJVerticalScroller.jsx';

const FJLanguageListMenu = props => {
    const _inputDebounce = useRef();
    const { selectedLanguage, list, onClick, isShow } = props;

    const [searchText, setSearchText] = useState('');
    const [showList, setShowList] = useState(list);

    useEffect(() => {
        if (!isShow) setSearchText('');
    }, [isShow]);

    useEffect(() => {
        _inputDebounce.current = _.debounce(text => {
            const t = text.trim().toLowerCase();
            if (!t) {
                setShowList(list);
            } else {
                const tList = list.filter(i => i.toLowerCase().startsWith(t));
                setShowList(tList);
            }
        }, 300);
    }, [list]);

    useEffect(() => {
        if (_inputDebounce.current) _inputDebounce.current(searchText);
    }, [searchText]);

    const _onInputChange = e => {
        setSearchText(e.target.value);
    };

    const _onClick = language => {
        onClick && onClick(language);
    };

    const _onDeleteSearch = () => {
        startTransition(() => {
            setSearchText('');
        });
    };

    const _renderList = () => {
        if (showList.length === 0) {
            return (
                <div className={styles.empty_box}>
                    <OppsIcon />
                    <p className={styles.text}>{`${FJLocalStore._('no-results')}"${searchText}"`}</p>
                </div>
            );
        } else {
            return showList.map((item, index) => {
                const isSelected = selectedLanguage === item;
                return (
                    <div key={item + index} className={styles.item} onClick={() => _onClick(item)}>
                        {FJLocalStore._(item)}
                        {isSelected && <CheckIcon className={styles.check} />}
                    </div>
                );
            });
        }
    };

    return (
        <div className={styles.box}>
            <div className={styles.search_box}>
                <SearchIcon className={styles.icon} />
                <input
                    className={styles.input}
                    value={searchText}
                    onChange={_onInputChange}
                    placeholder={FJLocalStore._('search-for-languages')}
                    maxLength={50}
                />
                {searchText && <DeleteSearchIcon className={styles.delete_search} onClick={_onDeleteSearch} />}
            </div>
            <FJVerticalScroller className={styles.scroller}>{_renderList()}</FJVerticalScroller>
        </div>
    );
};

export default FJLanguageListMenu;
